import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { createContext, useContext, useRef, useState, useLayoutEffect, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import { PopupsContext } from '../../helpers/popupsContext.js';
import { classNames } from '../../helpers/classnames.js';
import { getBEMClasses } from '../../helpers/get-bem.js';
import { Positioner } from './Positioner/Positioner.js';

var createPortalRoot = function (rootId, className, onBlur) {
    var rootElement = document.createElement('div');
    rootElement.id = rootId;
    if (className) {
        rootElement.className = className;
    }
    if (onBlur) {
        rootElement.addEventListener('blur', function (event) {
            return onBlur(event);
        }); //TODO: приходит нативное, а не синтетическое событие
        // нужно для корректной работы onBlur, по дефолту div не работает с событиями фокуса
        // TODO: поисследовать рефакторинг этого решения
        rootElement.contentEditable = 'true';
    }
    return rootElement;
};
var MENU_DEFAULT_OFFSET = 8;
var _a = getBEMClasses('dsb__dd-menu'), menuBlock = _a[0], menuModifier = _a[1];
var DropdownContext = createContext({});
var DropdownMenu = function (_a) {
    var _b = _a.verticalOffset, verticalOffset = _b === void 0 ? MENU_DEFAULT_OFFSET : _b, positionerClassName = _a.positionerClassName, _c = _a.horizontalOffset, horizontalOffset = _c === void 0 ? 0 : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, targetElement = _a.targetElement, className = _a.className, applicationRootElementIDProps = _a.applicationRootElementID, dropdownElementIDProps = _a.dropdownElementID, children = _a.children, onOpen = _a.onOpen, onBlur = _a.onBlur, onOutsideClick = _a.onOutsideClick, _e = _a.scrollable, scrollable = _e === void 0 ? true : _e, minHeight = _a.minHeight, _f = _a.dataTestId, dataTestId = _f === void 0 ? 'DropdownMenu' : _f, rest = __rest(_a, ["verticalOffset", "positionerClassName", "horizontalOffset", "align", "targetElement", "className", "applicationRootElementID", "dropdownElementID", "children", "onOpen", "onBlur", "onOutsideClick", "scrollable", "minHeight", "dataTestId"]);
    var _g = useContext(DropdownContext), applicationRootElementIDContext = _g.applicationRootElementID, dropdownElementIDContext = _g.dropdownElementID, rootElementDDContext = _g.rootElement;
    var _h = useContext(PopupsContext), applicationElementID = _h.applicationElementID, rootElementContext = _h.rootElement;
    var rootElementID = applicationRootElementIDProps || applicationRootElementIDContext || applicationElementID || 'root';
    var dropdownElementID = dropdownElementIDProps || dropdownElementIDContext || 'dsb__dropdown-root';
    var element = rootElementDDContext || rootElementContext;
    var dropdownMenuRef = useRef(null);
    var _j = useState(), rootElement = _j[0], setRootElement = _j[1];
    useLayoutEffect(function () {
        var mountElement = element || document.getElementById(rootElementID);
        if (!mountElement) {
            throw new Error("Application root element with ID \"".concat(rootElementID, "\" not found"));
        }
        var dropdownElement = createPortalRoot(dropdownElementID, className, onBlur);
        // dropdownElement.setAttribute('data-testid', 'DropdownMenu');
        Object.entries(rest).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            dropdownElement.setAttribute(key, value);
        });
        var root = mountElement.appendChild(dropdownElement);
        setRootElement(root);
        return function () {
            mountElement.removeChild(dropdownElement);
        };
        // rest намеренно не указан среди зависимостей, т.к приводит к неконтролируемым ререндерам
        // при этом присвоить эти параметры важно, а их изменение при открытом DropdownMenu маловероятно
        // TODO: подумать над переработкой этого блока - все зависимости хука должны быть указаны
    }, [rootElementID, dropdownElementID, className, element]);
    useEffect(function () { onOpen === null || onOpen === void 0 ? void 0 : onOpen(); }, []);
    useEffect(function () {
        var handleOutsideClick = function (event) {
            var targetElement = event === null || event === void 0 ? void 0 : event.composedPath()[0];
            var dropdownElement = dropdownMenuRef === null || dropdownMenuRef === void 0 ? void 0 : dropdownMenuRef.current;
            var isOutsideClick = dropdownElement && !dropdownElement.contains(targetElement);
            if (isOutsideClick) {
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
            }
        };
        var listenerContainer = rootElement || window;
        listenerContainer === null || listenerContainer === void 0 ? void 0 : listenerContainer.addEventListener('mousedown', handleOutsideClick);
        return function () { return listenerContainer === null || listenerContainer === void 0 ? void 0 : listenerContainer.addEventListener('mousedown', handleOutsideClick); };
    }, [onOutsideClick, rootElement]);
    var positionerProps = {
        positionerClassName: positionerClassName,
        align: align,
        horizontalOffset: horizontalOffset,
        targetElement: targetElement,
        verticalOffset: verticalOffset,
        scrollable: scrollable,
        minHeight: minHeight
    };
    var menuClass = classNames(menuBlock, menuModifier("align-".concat(align)));
    return ((rootElement &&
        ReactDOM.createPortal(React__default.createElement(Positioner, __assign({}, positionerProps),
            React__default.createElement("div", { ref: dropdownMenuRef, className: menuClass, contentEditable: false, "data-testid": dataTestId }, children)), rootElement)) ||
        null);
};

export { DropdownContext, DropdownMenu, createPortalRoot };
